import { jsx as _jsx } from "react/jsx-runtime";
import { motion, useAnimation } from "framer-motion";
import { useEffect, useRef } from "react";
export const ExpandUp = ({ children, startOnMount = true, stiffness = 250, duration = 0.5, delay = 0, slideEffect = true, width, height, style = {}, damping = 15, mass = 1, type = "spring" }) => {
    const wrapperRef = useRef();
    const controls = useAnimation();
    const hasAnimated = useRef(false);
    useEffect(() => {
        if (wrapperRef.current && startOnMount && !hasAnimated.current) {
            const elementHeight = wrapperRef.current.scrollHeight;
            if (slideEffect) {
                controls.start({
                    opacity: 1,
                    transform: "translateY(0%)",
                    transition: {
                        stiffness, duration, delay,
                        damping,
                        mass,
                        type,
                    },
                });
            }
            else {
                controls.start({
                    opacity: 1,
                    height: elementHeight,
                    transition: {
                        stiffness, duration, delay,
                        damping,
                        mass,
                        type,
                    },
                });
            }
            hasAnimated.current = true;
        }
    }, [wrapperRef.current, startOnMount, slideEffect]);
    if (slideEffect) {
        return (_jsx("div", { style: {
                width: "auto",
                height: height || (width ? "auto" : "130%"),
                overflow: "hidden",
                position: "relative",
                justifyContent: "center",
                alignItems: "center",
                ...(style || {})
            }, children: _jsx(motion.div, { ref: wrapperRef, animate: controls, initial: { transform: "translateY(100%)" }, style: {
                    width: width || (height ? "auto" : "100%"),
                    height: height || (width ? "auto" : "100%"),
                    display: 'flex',
                    justifyContent: "center",
                    alignItems: "center",
                    ...(style || {})
                }, children: children }) }));
    }
    return _jsx(motion.div, { ref: wrapperRef, animate: controls, initial: { height: 0, opacity: 0 }, style: {
            width: "100%",
            height: "100%",
            display: 'flex',
            ...(style || {})
        }, children: children });
};
